import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

let Bbps_category_flowise = () => {

  let [data, setData] = useState([]);
  let [count, setCount] = useState();
  let [indexs, setIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  let [opendata, setOpendata] = useState()

  let navigate = useNavigate();

  useEffect(() => { 
    Start();
    Payment();
  }, []);
      

  let [ pgtype , setPgtype ] = useState()
  let [ pgselect , setPgselect ] = useState()

  let [post, setPost] = useState(0)

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let Payment = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token ,};
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "get",
        url: Base_url_bbbs + "/adminbbps/get_bbps_gateway",
      })
        .then((dat) => { 
          console.log(dat.data.data, "datddddddddddddddddddddddddddddddddddddddd ");
        })
        .catch((ee) => {
          console.log(ee, "datddddddddddddddddddddddddddddddddddddddd ");
        });
    } catch (err) { }
  }

 
 let handleChange = async ( ) =>{
    try {
      let token = await localStorage.getItem("token");

      let pp = { token ,  pgtype , pgselect  };

      if( pgtype === "" || pgselect === "" || pgselect === undefined || pgselect === null || pgtype === null || pgtype === undefined ){

        alert("Select Fields")
      }

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/adminbbps/change_gateway",
        data: pp
      })
        .then((dat) => { 
          console.log(dat.data.data, "datddddddddddddddddddddddddddddddddddddddd ");
        })
        .catch((ee) => {
          console.log(ee, "datddddddddddddddddddddddddddddddddddddddd ");
        });
    } catch (err) { }
 }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-8" style={{ overflowY: 'scroll', height: '100vh', scrollbarWidth: 'none' }} >
          <p style={{ fontWeight: '700', fontSize: 15, marginTop: 5 }} >BBps Flowise</p>
          <div className="row mt-4 ">
            <div className='col-3' >
              <p style={{ fontWeight: '500', fontSize: 13,  }} >Upi</p>
                <select
                  onChange={(e) => 
                  {

                    setPgtype("upi")
                    setPgselect(e.target.value)
                  }
                  } 
                  // value={block.pro}
                  style={{ width: "98%" }}
                >
                  <option value="" disabled selected>
                    -- Select PG --
                  </option>
                  <option value="1">Phonepe</option>
                  <option value="2">Payu Alpha (old)</option>
                  <option value="3">Payu Beta (new)</option>
                  <option value="5">Bill Desk</option>
                </select>
            </div>
            <div className='col-3' >
              <p style={{ fontWeight: '500', fontSize: 13,  }} >Net banking</p>
              <select
                onChange={(e) =>
                {
                  setPgtype("net")
                  setPgselect(e.target.value)
                }
                }
                // value={block.pro}
                style={{ width: "98%" }}
              >
                <option value="" disabled selected>
                    -- Select PG --
                </option>
                <option value="1">Phonepe</option>
                <option value="2">Payu Alpha (old)</option>
                <option value="3">Payu Beta (new)</option>
                <option value="5">Bill Desk</option>
              </select>
            </div>
            <div className='col-3' >
              <p style={{ fontWeight: '500', fontSize: 13,  }} >Credit Card</p>
              <select
                onChange={(e) =>
                {

                   setPgtype("cc")
                    setPgselect(e.target.value)
                }
                }
                // value={block.pro}
                style={{ width: "98%" }}
              >
                <option value="" disabled selected>
                    -- Select PG --
                </option>
                <option value="1">Phonepe</option>
                <option value="2">Payu Alpha (old)</option>
                <option value="3">Payu Beta (new)</option>
                <option value="5">Bill Desk</option>
              </select>
            </div>
            <div className='col-3' >
              <p style={{ fontWeight: '500', fontSize: 13,  }} >Wallet</p>
              <select
                onChange={(e) =>
                {

                  setPgtype("wallet")
                  setPgselect(e.target.value)
                }
                }
                // value={block.pro}
                style={{ width: "98%" }}
              >
                <option value="" disabled selected>
                    -- Select PG --
                </option>
                <option value="1">Phonepe</option>
                <option value="2">Payu Alpha (old)</option>
                <option value="3">Payu Beta (new)</option>
                <option value="5">Bill Desk</option>
              </select>
            </div>  
          </div>
          <div >
            <button onClick={handleChange} className="btn btn-primary" style={{ marginTop: 10, width: "10%" }}>
              Save
            </button>
          </div>
        </div>
      </div>
 
    </div>
  );
};

export default Bbps_category_flowise;
